import useSWR from 'swr';
import axiosInstance from 'apis/axiosInstance';
import { loadSelectedClinicId } from 'utils/storage';
import { Operatory } from 'interfaces/operatory';

const useOperatory = () => {
  const clinicId = loadSelectedClinicId();
  const { data, error, mutate } = useSWR(
    ['/operatories', clinicId],
    async (...resource) => {
      const [url] = resource;
      const response = await axiosInstance.get<Operatory[]>(url);
      return response.data;
    }
  );

  return {
    data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};

export default useOperatory;
